// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1Wlo3","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__14Fud"};